import type { HandFrame } from "../utils/types.ts";
import {
  createGestureState,
  stepGestureMachine,
  type GestureOutput,
} from "./GestureStateMachine.ts";

/** Owns the gesture state machine so a single noisy frame cannot fire effects. */
export class GestureRecognizer {
  private state = createGestureState();

  reset(): void {
    this.state = createGestureState();
  }

  step(hands: HandFrame[], timestamp: number, sensitivity: number): GestureOutput {
    return stepGestureMachine(this.state, { hands, timestamp }, sensitivity);
  }
}
